import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import VerifyCodeForm from './forms/VerifyCodeForm';

function VerifyCode() {
  const { params } = useRouteMatch();
  const { type } = params;

  return (
    <>
      <div className="mb-8">
        <h4 className="text-lg text-primary-500 font-semibold">
          Enter 6-digit recovery code
        </h4>
        <p className="text-base text-gray-400 text-opacity-75 font-light">
          {type === 'mobile'
            ? 'The recovery code was sent to your mobile number.'
            : 'The recovery code was sent to your email.'}
        </p>
        <p className="text-base text-gray-400 text-opacity-75 font-light">
          Please enter the code.
        </p>
      </div>
      <VerifyCodeForm />
    </>
  );
}
VerifyCode.defaultProps = {};

VerifyCode.propTypes = {};

export default VerifyCode;
